var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.1667C12.0084 20.1667 12.8334 19.3417 12.8334 18.3334H9.16671C9.16671 19.3417 9.98255 20.1667 11 20.1667ZM16.5 14.6667V10.0834C16.5 7.26925 14.9967 4.91341 12.375 4.29008V3.66675C12.375 2.90591 11.7609 2.29175 11 2.29175C10.2392 2.29175 9.62505 2.90591 9.62505 3.66675V4.29008C6.99421 4.91341 5.50005 7.26008 5.50005 10.0834V14.6667L4.31755 15.8492C3.74005 16.4268 4.14338 17.4167 4.95921 17.4167H17.0317C17.8475 17.4167 18.26 16.4268 17.6825 15.8492L16.5 14.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.0038fb4069cd17614696c606116e9bf3.svg";
export { ForwardRef as ReactComponent };